<template>
  <a-modal :visible="open" title="绑定关联商品" width="900px" :confirm-loading="saving" ok-text="确定"
    cancel-text="取消" :mask-closable="false" destroy-on-close wrap-class-name="bind-product-modal"
    @ok="handleOk" @cancel="handleCancel">
    <a-space direction="vertical" style="width: 100%">
      <a-checkbox v-model:checked = "allChecked" @change = "onAllCheckedChange">所有商品参与</a-checkbox>
      
        <a-form layout="inline" :model="formState">
          <a-form-item label="商品名称">
            <a-input v-model:value="searchName" placeholder="请输入商品名称" allowClear
              style="width: 220px; margin-right: 10px;" @pressEnter="search" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="search">搜索</a-button>
            <a-button style="margin-left: 8px" @click="resetSearch">重置</a-button>
          </a-form-item>
        </a-form>

        <div class="block-title">已关联商品（{{ boundProducts.length }}）</div>
        <a-table class="ant-table-striped" :columns="boundColumns" :data-source="boundProducts" rowKey="id"
          :pagination="false" size="small" bordered :scroll="{ y: 180 }"
          :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)">
          <template #thumbnail="{ record }">
            <a-image v-if="record.thumbnailUuid" :src="imageUrl + record.thumbnailUuid" :width="40" :height="40"
              style="object-fit: cover; border-radius: 4px;" alt="缩略图" />
            <span v-else>-</span>
          </template>
          <template #operation="{ record }">
            <a-button type="link" size="small" @click="removeBound(record)">移除</a-button>
          </template>
        </a-table>

        <div class="block-title">全部商品</div>
        <a-table class="ant-table-striped" :columns="allColumns" :data-source="availableProducts" rowKey="id"
          :pagination="{ pageSize: 6 }" size="small" bordered :scroll="{ y: 220 }"
          :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)">
          <template #thumbnail="{ record }">
            <a-image v-if="record.thumbnailUuid" :src="imageUrl + record.thumbnailUuid" :width="40" :height="40"
              style="object-fit: cover; border-radius: 4px;" alt="缩略图" />
            <span v-else>-</span>
          </template>
          <template #operation="{ record }">
            <a-button type="link" size="small" @click="addToBound(record)">添加</a-button>
          </template>
        </a-table>

      <!--<div v-else style="color: #999;">当前所有商品参与优惠</div>-->
    </a-space>
  </a-modal>
</template>

<script>
import { message } from "ant-design-vue";
import {
  GetProductList,
  AddPromotionProducts,
  GetPromotionProducts,
  DeletePromotionProduct,
  UpdatePromotion,
} from "/src/api/shopping.js";

export default {
  name: "优惠绑定关联商品弹窗",
  props: {
    open: { type: Boolean, default: false },
    promotionId: { type: [Number, String], default: undefined },
    // 该优惠已关联的商品，用于回显到「已关联商品」表格
    initialProducts: { type: Array, default: () => [] },
    // true：点「确定」直接调用关联接口保存；false：仅把选中的商品回传（saved 事件），由父组件保存后再绑定（用于新建还未拿到 id 的场景）
    immediateSave: { type: Boolean, default: true },
    isGlobal: { type: Boolean, default: false},
  },
  emits: ["update:open", "saved"],
  data() {
    return {
      searchName: undefined,
      allProducts: [],
      boundProducts: [],
      // 本次新增待保存的商品（无 relationId）
      addedProducts: [],
      loading: false,
      saving: false,
      imageUrl: '/api/file/img/thumbnail/',
      allChecked: false,
      fullProducts: [],
      boundColumns: [
        { title: "商品名称", dataIndex: "name", key: "name", width: "35%" },
        { title: "缩略图", dataIndex: "thumbnailUuid", key: "thumbnailUuid", width: "20%", slots: { customRender: "thumbnail" } },
        { title: "类型", dataIndex: "category", key: "category", width: "15%" },
        { title: "单位", dataIndex: "packageUnit", key: "packageUnit", width: "10%" },
        { title: "操作", key: "operation", width: "15%", slots: { customRender: "operation" } },
      ],
      allColumns: [
        { title: "商品名称", dataIndex: "name", key: "name", width: "35%" },
        { title: "缩略图", dataIndex: "thumbnailUuid", key: "thumbnailUuid", width: "20%", slots: { customRender: "thumbnail" } },
        { title: "类型", dataIndex: "category", key: "category", width: "15%" },
        { title: "单位", dataIndex: "packageUnit", key: "packageUnit", width: "10%" },
        { title: "操作", key: "operation", width: "15%", slots: { customRender: "operation" } },
      ],
    };
  },
  computed: {
    // 下方「全部商品」列表去掉已关联的商品，避免重复
    availableProducts() {
      return (this.allProducts || []).filter((p) => !this.isBound(p));
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.loadInitial();
      }
    },
  },
  methods: {
    // 打开弹窗时初始化「已关联商品」：有 promotionId 则查询接口，否则用父组件传入的 initialProducts
    async loadInitial() {
      this.addedProducts = [];
      if (this.promotionId !== undefined && this.promotionId !== null && String(this.promotionId) !== "") {
        try {
          const res = await GetPromotionProducts({ promotionId: this.promotionId });
          if (res.errCode === 0) {
            this.boundProducts = (res.data || []).map((p) => this.normalizeProduct(p));
          } else {
            message.error(res.errMsg || "查询已关联商品失败");
            this.boundProducts = [];
          }
        } catch (error) {
          console.error("load promotion products error:", error);
          message.error("请求异常，请稍后重试");
          this.boundProducts = [];
        }
      } else {
        this.boundProducts = (this.initialProducts || []).map((p) => this.normalizeProduct(p));
      }
      this.searchName = "";
      //this.search();
      await this.search();
      this.allChecked = !!this.isGlobal;
      if (this.allChecked) {
        this.selectAllProducts();
      }
    },
    // 将接口返回的关联记录/商品记录规范化为表格可用对象（包装结构 -> 商品字段，并保留关联记录 id）
    normalizeProduct(p) {
      if (!p) return p;
      // 已关联接口返回 { id, promotionId, productId, product: {...} }，其中外层 id 是关联记录 id
      const relationId = p.id !== undefined && p.id !== null ? p.id : undefined;
      const product = p.product && typeof p.product === "object" ? p.product : null;
      if (product) {
        return {
          // 行主键用商品 id，用于表格 rowKey 与去重
          id: product.id !== undefined && product.id !== null ? product.id : p.productId,
          relationId,
          name: product.name,
          thumbnailUuid: product.thumbnailUuid,
          category: product.category,
          packageUnit: product.packageUnit,
          price: product.price,
        };
      }
      // 无 product 子对象时，用 productId 兜底为 id
      return {
        id: p.productId !== undefined && p.productId !== null ? p.productId : p.id,
        relationId,
        name: p.name,
        thumbnailUuid: p.thumbnailUuid,
        category: p.category,
        packageUnit: p.packageUnit,
        price: p.price,
      };
    },
    getProductId(p) {
      return p.id;
    },
    isBound(record) {
      return this.boundProducts.some((b) => this.getProductId(b) === this.getProductId(record));
    },
    addToBound(record) {
      if (document.activeElement && typeof document.activeElement.blur === "function") {
        document.activeElement.blur();
      }

      if (this.isBound(record)) return;
      const plain = { ...record };
      this.boundProducts.push(plain);
      // 记录为新增（无 relationId），供确定时 POST 关联
      this.addedProducts.push(plain);

      this.syncAllCheckedByCount();
    },
    // 全选联动：已选商品 >= 总数时勾选 "所有商品参与"；移除后不足总数则取消勾选
    syncAllCheckedByCount() {
      if (this.fullProducts.length > 0) {
        this.allChecked = this.boundProducts.length >= this.fullProducts.length;
      }
    },
    async removeBound(record) {
      if (document.activeElement && typeof document.activeElement.blur === "function") {
        document.activeElement.blur();
      }
      const key = this.getProductId(record);
      const target = this.boundProducts.find((b) => this.getProductId(b) === key);
      if (!target) return;
      // 本次新增（尚未保存）的商品：直接本地移除，无需调接口
      if (target.relationId === undefined || target.relationId === null) {
        this.boundProducts = this.boundProducts.filter((b) => this.getProductId(b) !== key);
        this.addedProducts = this.addedProducts.filter((a) => this.getProductId(a) !== key);
        this.syncAllCheckedByCount();
        return;
      }
      // 已存在关联：调用删除接口，成功后从列表移除
      try {
        const delRes = await DeletePromotionProduct({ id: target.relationId });
        if (delRes.errCode === 0) {
          this.boundProducts = this.boundProducts.filter((b) => this.getProductId(b) !== key);
          this.addedProducts = this.addedProducts.filter((a) => this.getProductId(a) !== key);
          this.syncAllCheckedByCount();
          message.success("删除关联成功");
        } else {
          message.error(delRes.errMsg || "删除关联失败");
        }
      } catch (error) {
        console.error("delete promotion product error:", error);
        message.error("请求异常，请稍后重试");
      }
    },
    resetSearch() {
      this.searchName = "";
      this.search();
    },
    handleCancel() {
      this.$emit("update:open", false);
    },
    async search() {
      this.loading = true;
      const params = { name: this.searchName ? this.searchName.trim() : undefined };
      try {
        const res = await GetProductList(params);
        if (res.errCode === 0) {
          this.allProducts = res.data || [];
          if (!this.searchName) {
            this.fullProducts = [...this.allProducts];
          }
        } else {
          message.error(res.errMsg || "查询失败");
        }
      } catch (error) {
        console.error("Search error:", error);
        message.error("请求异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    async handleOk() {
      // 非立即保存模式：仅把选中的商品回传给父组件（如新建场景，等父组件拿到优惠 id 后再绑定）
      if (!this.immediateSave) {
        this.$emit("saved", this.boundProducts.map((p) => ({ ...p })));
        this.$emit("update:open", false);
        return;
      }
      if (this.promotionId === undefined || this.promotionId === null) {
        message.error("缺少优惠ID，无法关联商品");
        return;
      }
      this.saving = true;
      try {
        // 1.“所有商品参与”状态变化时，先持久化 isGlobal
        if (this.allChecked !== !!this.isGlobal) {
          const gRes = await UpdatePromotion({ id: this.promotionId, isGlobal: this.allChecked});
          if (gRes.errCode !== 0) {
            message.error(gRes.errMsg || "更新参与范围失败");
            return;
          }
        }
        // 2.非“所有商品”时，把本次新增的商品关联上
        if (!this.allChecked) {
          const productIds = this.addedProducts
          .map((p) => this.getProductId(p))
          .filter((v) => v !== undefined && v !== null);
          if (productIds.length > 0) {
            const relRes = await AddPromotionProducts({ promotionId: this.promotionId, productIds});
            if (relRes.errCode !== 0) {
              message.error(relRes.errMsg || "关联失败");
              return;
            }
          }
        }
        // 3.无论是否新增，都通知父组件刷新列表
        this.$emit("saved", this.boundProducts.map((p) => ({...p})));
        this.$emit("update:open", false);
      } catch (error) {
        console.error("save scope error:", error);
        message.error("请求异常，请稍后重试");
      } finally {
        this.saving = false;
      }
    },
    onAllCheckedChange() {
      if (this.allChecked) {
        this.selectAllProducts();
      }
    },
    // 把完整商品列表里尚未关联的商品全部加入
    selectAllProducts() {
      const existingIds = new Set(this.boundProducts.map((p) => this.getProductId(p)));
      const toAdd = (this.fullProducts || []).filter((p) => !existingIds.has(this.getProductId(p)));
      if (!toAdd.length)  return;
      const plain = toAdd.map((p) => ({...p}));
      this.boundProducts = [...this.boundProducts, ...plain];
      this.addedProducts = [...this.addedProducts, ...plain];
    },
  },
};
</script>

<style scoped>
.block-title {
  font-weight: 600;
  margin: 4px 0 8px;
}

/* 限制弹窗整体高度，超出的部分在内容区滚动 */
.bind-product-modal ::v-deep(.ant-modal) {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.bind-product-modal ::v-deep(.ant-modal-header) {
  flex: none;
}

.bind-product-modal ::v-deep(.ant-modal-footer) {
  flex: none;
}

.bind-product-modal ::v-deep(.ant-modal-body) {
  overflow-y: auto;
  max-height: calc(92vh - 120px);
  padding: 16px 24px;
}
</style>